import React, { useState } from 'react';
import { CheckCircleIcon, XCircleIcon } from '@heroicons/react/24/solid';
import { newsletterSignup } from '@services/api/newsletter/newsletterService';
import Button from '@components/button';
import { messages } from '@constants/index';

/**
 * Newsletter sign up component
 */
const NewsletterSignUp = () => {
  const [email, setEmail] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  /**
   * Submit email to the newsletter API
   * @param {string} email
   * @returns {Promise<void>}
   */
  const submitEmail = async email => {
    const response = await newsletterSignup(email);
    if (response.message === 'success') {
      setSuccessMessage(() => messages.SUBSCRIBED.replace('{email}', email));
      setErrorMessage(() => '');
      setEmail(() => '');
    } else {
      setSuccessMessage('');
      setErrorMessage(messages.EMAIL_SUBSCRIBED_ERROR);
    }
  };

  const handleSubmit = e => {
    e.preventDefault();
    submitEmail(email);
  };

  return (
    <div className='flex flex-col order-first xl:order-last mx-[18px] md:mx-[32px] lg:mx-0 xl:w-2/5 mb-[40px] xl:mb-0'>
      <h2 className='text-[32px] leading-10 font-Roman mb-2.5'>
        Sign up for our Newsletter
      </h2>
      <p className='text-sm leading-5 font-Roman mb-[25px]'>
        Receive email communications about Kohler Energy products,
        promotions and tips.
      </p>
      <form
        className='flex flex-col md:flex-row'
        data-testid='NewsletterSignUp'
        onSubmit={handleSubmit}
      >
        <div className='flex border-b border-gray-400 mb-[15px] md:w-full md:pr-36'>
          <label htmlFor='email' className='sr-only'>
            Email Address
          </label>
          <input
            type={'email'}
            id='email'
            data-testid='email'
            required
            autoComplete='email'
            value={email}
            onChange={e => setEmail(e.target.value)}
            className='w-full bg-transparent text-gray-500 border-none font-Roman text-xl leading-7 pl-2 pt-3 appearance-none focus:outline-none pb-[15px]'
            placeholder='Enter your email address'
          />
        </div>

        <Button
          variant='primary'
          type='submit'
          className='flex xs:w-full place-content-center leading-[14px] text-sm font-BallingerMonoMd mb-10 md:-ml-32 md:mb-[25px]'
        >
          SUBSCRIBE
        </Button>
      </form>
      {successMessage && (
        <p className='flex text-success mb-[15px]'>
          <CheckCircleIcon className='h-6 w-6 mr-1 pb-1' />
          <span className='text-sm leading-5'>{successMessage}</span>
        </p>
      )}
      {errorMessage && (
        <p className='flex text-danger mb-[15px]'>
          <XCircleIcon className='h-6 w-6 mr-1 pb-1.5' />
          <span className='text-sm leading-5'>{errorMessage}</span>
        </p>
      )}
    </div>
  );
};

export default React.memo(NewsletterSignUp);
